import {
	DateObject,
	type FetchPledgeCampaignBonusByCampaignData,
	type FetchPledgeCampaignBonusByCampaignParams,
	pledgeApi
} from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';

export const usePledgeEstimatedCampaignBonusQuery = (params: FetchPledgeCampaignBonusByCampaignParams) => {
	const currentDateKey = new DateObject().toISOString().split('T')[0];

	return useQuery({
		enabled: !!params.campaign && !!params.amount,
		gcTime: 1000 * 60 * 60 * 25,
		queryFn: async () => {
			return (await pledgeApi).fetchPledgeCampaignBonusByCampaign(
				params
			) as Promise<FetchPledgeCampaignBonusByCampaignData>;
		},
		queryKey: ['pledge-estimated-campaign-bonus', params, currentDateKey],
		select: res => res.data,
		staleTime: Infinity // Never stale - date key handles day transitions
	});
};
